export enum EEscapesEvents {
  ESCAPES_PILL_ON_HOME = 'escapes_pill_on_home',
}

export enum EEscapesSource {
  PRODUCT_OFFERINGS = 'product_offerings',
}

export enum EEscapesTab {
  RV_RENTALS = 'RV Rentals',
  ESCAPES = 'Escapes',
  DELIVERY = 'RV Delivery',
}

export interface IEscapesPillOnHome {
  tab: EEscapesTab | string;
  source: EEscapesSource;
}
